import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Button, FormLabel, Grid, TextField } from "@mui/material";
import ReactJson from "@microlink/react-json-view";
import { useController } from "react-hook-form";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import FormField from "./FormField";

function FormJson({ name, textFieldType, label, tKey, tDefault, ...props }) {
  const [showRawTextField, setShowRawTextField] = useState(false);

  const {
    field: { value, onChange },
    fieldState: { isDirty },
  } = useController({ name });

  const isValidJson = useCallback((v) => {
    try {
      JSON.parse(v);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Button
          checked={showRawTextField}
          color={"primary"}
          onClick={(e) => {
            setShowRawTextField(!showRawTextField);
          }}
          size={"small"}
          style={{ fontWeight: showRawTextField ? 800 : null }}
          variant={"outlined"}
        >
          Raw Text
        </Button>
      </Grid>
      {showRawTextField ? (
        <FormField
          {...props}
          Field={TextField}
          fieldProps={({ value, onChange }) => {
            if (!isDirty) {
              try {
                if (typeof value === "string") {
                  value = JSON.stringify(JSON.parse(value), null, 2) ?? "";
                } else {
                  value = JSON.stringify(value, null, 2) ?? "";
                }
              } catch (e) {
                value = value ?? "";
              }
            }
            return {
              onChange: (e) => {
                if (e.target.value === "") {
                  onChange(null);
                } else {
                  onChange(e.target.value);
                }
              },
              type: textFieldType,
              value: value,
              multiline: true,
              rows: 25,
            };
          }}
          name={name}
          rules={{
            validate: isValidJson,
          }}
        />
      ) : (
        <>
          <Grid item>
            <FormLabel>
              {label ? label : tKey ? <TranslationWrapper tDefault={tDefault ?? tKey} tKey={tKey} /> : null}
            </FormLabel>
          </Grid>
          <Grid item>
            <ReactJson
              onAdd={(e) => {
                onChange(e.updated_src === "" ? null : JSON.stringify(e.updated_src));
              }}
              onDelete={(e) => {
                onChange(e.updated_src === "" ? null : JSON.stringify(e.updated_src));
              }}
              onEdit={(e) => {
                onChange(e.updated_src === "" ? null : JSON.stringify(e.updated_src));
              }}
              quotesOnKeys={true}
              sortKeys={true}
              src={typeof value === "string" ? JSON.parse(value) : (value ?? {})}
            />
          </Grid>
        </>
      )}
    </>
  );
}

FormJson.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  textFieldType: PropTypes.string,
  stringifyJson: PropTypes.bool,
};

FormJson.defaultProps = {
  textFieldType: "text",
  stringifyJson: true,
};

export default FormJson;
